<template>
  <div id="app">
    <v-header></v-header>
    <div class="kr-layout" data-reactroot>
      <div :class="['kr-layout-main', 'clearfloat', p?'':'active']">
        <!--左边列表-->
        <div class="main-left">
          <div class="kr-sider">
            <div class="kr-sider-shadow-wrapper clearfloat">
              <ul v-if="p" class="kr-channel-nav">
                <li :class="{'channel-item':true, 'active':k == 0}" @click="iPage">
                  <div class="sub-title active">首页</div>
                </li>
                <li :class="{'channel-item':true, 'active':k == 1}">
                  <!-- <div class="sub-title info" @click="infor()">行业</div> -->
                  <div class="sub-title info" @click="infor()">记录</div>
                  <span class="iconfont icon-fanhui" :class="{'active':isActive}" @click="upload"></span>
                  <ul :class="{'active':isActive}" class="child">
                    <li
                      v-for="(item,index) in List"
                      :key="index"
                      v-if="item.categoryName !='档案馆'"
                      :class="n == index? 'active':''"
                      @click="trans(index,item.id)"
                    >{{item.categoryName}}</li>
                  </ul>
                </li>
                <li
                  v-for="(item,index) in rout"
                  :key="index"
                  :class="{'channel-item':true, 'active':k == index+2}"
                  @click="leftList(index+2,item.path)"
                >
                  <div class="sub-title">{{item.title}}</div>
                </li>
                <li tag="li" class="search" @click="search">
                  搜索
                  <i class="iconfont icon-sousuo-copy"></i>
                </li>
              </ul>
              <ul v-else class="kr-channel-nav">
                <li
                  v-for="(item,index) in mediaRout"
                  :key="index"
                  :class="{'channel-item':true, 'active': ki == index}"
                  @click="nextLeftList(index,item.path)"
                >
                  <div class="sub-title">{{item.title}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="main-right">
          <router-view />
        </div>
      </div>
    </div>
    <v-footer></v-footer>
    <v-search v-if="seek"></v-search>
  </div>
</template>
<script>
import $ from "jquery";
import Header from "./public/header";
import footer from "./public/footer";
import search from "./search";
export default {
  data() {
    return {
      maskShow: false,
      seek: false,
      isfont: true,
      isActive: false,
      List: [],
      k: 0,
      ki: 0,
      routeUrl: "",
      rout: [
        //个人
        {
          title: "视频",
          path: "/video"
        },
        {
          title: "档案",
          path: "/special"
        },
        {
          title: "活动",
          path: "/activity"
        },
        // {
        //   title: "工作",
        //   path: "/invite"
        // }
      ],
      mediaRout: [
        //媒体人
        {
          title: "首页",
          path: "/iPage_sub"
        },
        {
          title: "内容发布",
          path: "/publish",
        },
        {
          title: "图文管理",
          path: "/graphicManage"
        },
        {
          title: "动态管理",
          path: "/dynamiManage"
        },
        {
          title: "视频管理",
          path: "/videoManage"
        },
        // {
        //   title: "工作管理",
        //   path: "/inviteManage"
        // },
        {
          title: "账户管理",
          path: "/setAccount"
        },
		// {
		//   title: "数据分析",
		//   path: "/dataAnalysis"
		// },
		// {
		//   title: "我的粉丝",
		//   path: "/myFans"
		// },
		{
		  title: "修改密码",
		  path: "/perData"
		},
      ]
    };
  },
  computed: {
    n() {
      return this.$store.state.navigaterLevel2Index;
    },
    p() {
      console.log(this.$store.state.userPersonSatus);
      return this.$store.state.userPersonSatus;
    },
    role() {
      return this.$store.state.userInfo.role;
    }
  },
  components: {
    "v-header": Header,
    "v-footer": footer,
    "v-search": search
  },
  mounted() {
  
    this.getList();
    this.$store.commit("getNavindex");
    if (this.role > 1) {
      this.ki = this.$store.state.setleftNav;
    } else {
      this.k = this.$store.state.setleftNav;
    }
    this.getStatus();
  },
  methods: {
    getStatus() {
      this.$http
        .get("/api/media/007--accountSetting", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          console.log(res, "获取认证状态");
          if (res.data.code == 0) {
              if(res.data.rows[0].status == 3) {
                this.$store.commit("userPerson", { a: false});
              }else{
                this.$store.commit("userPerson", { a: true });
              }
          } 
        })
        .catch(err => {
          console.log(err);
        });
    },
    iPage() {
      this.k = 0;
      this.routeUrl = this.$router.resolve({ path: "/iPage" });
      window.open(this.routeUrl.href, "_blank");
    },
    infor() {
      this.k = 1;
      this.routeUrl = this.$router.resolve({ path: "/information" });
      this.$store.state.navigaterLevel2Index = 0;
      this.$store.state.navigaterLevel2Id = null;
      this.$store.commit("setNavindex", { ind: 1 });
      window.open(this.routeUrl.href, "_blank");
    },
    leftList(i, path,n) {
      this.k = i;
      this.$store.commit("setNavindex", { ind: i });
      this.routeUrl = this.$router.resolve(path);
      window.open(this.routeUrl.href, "_blank");
    },
    nextLeftList(i, path) {
      this.ki = i;
      this.$store.commit("setNavindex", { ind: i });
      this.routeUrl = this.$router.resolve(path);
      window.open(this.routeUrl.href, "_blank");
      if(i==1){
        this.$store.commit("arcId", { data: null});
        this.$store.commit("postpubId", { data: null });
      }
    },
    search() {
      this.seek = true;
    },
    upload() {
      this.isActive = !this.isActive;
    },
    getList() {
      //获取推荐信息
      this.$http
        .get("/api/core/001--CusCategoryList", {
          params: {
            type: 1
          }
        })
        .then(res => {
          console.log(res, "城市列表");
          if (res.status == 200 && res.data.code == 0) {
            this.List = res.data.rows;
          }
        });
    },
    trans(i, id) {
      this.k = 1;
      this.$store.commit("setNavindex", { ind: 1 });
      this.$router.push({ path: "/information" });
      this.$store.commit("setIndexId", { index: i, id: id });
    }
  }
};
</script>
<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
@media (min-width: 375px) and (max-width: 500px) {
  .kr-layout .kr-layout-main .main-left {
    display: none;
  }
  .kr-sider {
    display: none;
  }
  .kr-channel-nav .channel-item .child {
    display: none;
  }
  .kr-channel-nav .channel-item span {
    display: none;
  }
}
.kr-layout .kr-layout-main.active {
  width: calc(100% + 120px);
  margin-left: -120px;
}
.kr-layout .kr-layout-main.active .main-left {
  background: #eee;
  width: 220px;
  margin: 20px 0px 0px 0px;
  text-indent: -30px;
}
.kr-layout .kr-layout-main.active .kr-sider {
  width: 100%;
}
.kr-layout .kr-layout-main.active .kr-channel-nav .channel-item .sub-title {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.kr-layout .kr-layout-main.active .kr-channel-nav .channel-item {
  height: 40px;
  margin: 0px 0px;
  font-size: 16px;
}
@media (min-width: 720px) and (max-width: 799px) {
  .kr-layout .kr-layout-main.active .main-left {
    width: 200px;
  }
}
@media (min-width: 320px) and (max-width: 500px) {
  .kr-layout .kr-layout-main.active {
    width: 100% !important;
    margin-left: 0px !important;
  }
}
</style>
